import { useAtomValue, useSetAtom } from "jotai";
import { useMemo } from "react";

import { $httpRequestPage, $httpRequestPageError } from "../../internal/request-page";
import { requestPageKeyForDocsRoute } from "../../internal/request-page/requestPageKey";

export const useHttpRequestPage = (documentId: string, pageId: string) => {
	const httpRequestPageKey = useMemo(
		() => requestPageKeyForDocsRoute({ documentId, pageId }),
		[documentId, pageId]
	);

	// HTTP request page atoms
	const httpRequestPage = useAtomValue($httpRequestPage(httpRequestPageKey));
	const setHttpRequestPage = useSetAtom($httpRequestPage(httpRequestPageKey));
	const error = useAtomValue($httpRequestPageError(httpRequestPageKey));

	return {
		/** The unique key for this http request page instance */
		httpRequestPageKey,
		/** The current HTTP request page record, or null if not loaded */
		httpRequestPage,
		/** Dispatch an update to the http request page */
		setHttpRequestPage,
		/** The http request page error, if any */
		error,
		/** True while the http request page is loading */
		isLoading: !httpRequestPage,
		/** True if there was an error loading the http request page */
		isError: !!error,
	};
};
